import React from 'react';
import { useScrollDirection } from '@hooks/useScrollDirection';
import type { StrapiHeaderNavItem } from '@customTypes/strapiData';
import { BaseContainer } from '@periodica/ui-kit';
import { Menu } from '../Menu';
import { Logo } from '../Logo';
import * as styles from './index.module.css';

type MobileHeaderArgs = {
  items: StrapiHeaderNavItem[];
  scrollOffset: number;
  isMainPage: boolean;
};

export function MobileHeader({ items, scrollOffset, isMainPage }: MobileHeaderArgs) {
  const scrollDirection = useScrollDirection();

  return (
    <div
      className={styles.wrapper}
      style={{
        transform: scrollDirection === 'down' ? `translateY(-${scrollOffset}px)` : undefined,
      }}
    >
      <BaseContainer className={styles.container}>
        {isMainPage ? (
          <div className={styles.logoContainer}>
            <Logo />
          </div>
        ) : null}
        <div className={styles.menuContainer}>
          <div className={styles.menuContent}>
            <Menu items={items} useIntersectionObserver />
          </div>
        </div>
      </BaseContainer>
    </div>
  );
}
